import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from "react";
import DropdownMenu from "../../components/common/DropdownMenu";
import SectionedDropdownMenu from "../../components/common/SectionedDropdownMenu";
import TagItem from "../../components/PatientTags/TagItem";
import { faPlus, faCalendar } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../../components/AwesomeIcon";
import { useAddBulkTagging } from "../../components/Assistant/utils/actions/useAddBulkTagging";
import { t } from "i18next";
var BulkAssignBar = function BulkAssignBar(_ref) {
  var _assigneeField$proper;
  var selectedCount = _ref.selectedCount,
    customFields = _ref.customFields,
    onAssign = _ref.onAssign,
    onSelectAssignee = _ref.onSelectAssignee,
    onUpdateFields = _ref.onUpdateFields,
    selectedAssignee = _ref.selectedAssignee,
    workspaceId = _ref.workspaceId,
    selectedPatientIds = _ref.selectedPatientIds,
    isBulkTaggingInProgress = _ref.isBulkTaggingInProgress,
    isUpdating = _ref.isUpdating;
  var _useState = useState(""),
    customFieldSearch = _useState[0],
    setCustomFieldSearch = _useState[1];
  var _useState2 = useState([]),
    fieldSelections = _useState2[0],
    setFieldSelections = _useState2[1];
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === " ") {
      e.stopPropagation();
    }
  };
  var isAssigneeField = function isAssigneeField(field) {
    return field.tag_type === "user" && field.tag === "Assignee" && field.additional.isSystemField === true;
  };
  var assigneeField = customFields === null || customFields === void 0 ? void 0 : customFields.find(isAssigneeField);
  var assigneeOptions = (assigneeField === null || assigneeField === void 0 || (_assigneeField$proper = assigneeField.properties) === null || _assigneeField$proper === void 0 ? void 0 : _assigneeField$proper.options) || [];

  // Only allow fields not already selected and not the Assignee field
  var availableCustomFields = customFields === null || customFields === void 0 ? void 0 : customFields.filter(function (field) {
    return field.additional.isEnabled && !fieldSelections.some(function (sel) {
      return sel.field.uuid === field.uuid;
    }) && !isAssigneeField(field);
  });
  var filteredCustomFields = availableCustomFields === null || availableCustomFields === void 0 ? void 0 : availableCustomFields.filter(function (field) {
    return field.tag.toLowerCase().includes(customFieldSearch.toLowerCase());
  });

  // Group filtered custom fields by section
  var groupedCustomFields = filteredCustomFields === null || filteredCustomFields === void 0 ? void 0 : filteredCustomFields.reduce(function (acc, field) {
    var _field$properties;
    var section = ((_field$properties = field.properties) === null || _field$properties === void 0 ? void 0 : _field$properties.section) || "Other";
    if (!acc[section]) {
      acc[section] = [];
    }
    acc[section].push(field);
    return acc;
  }, {});

  // Convert grouped fields to sections format for SectionedDropdownMenu
  var sections = groupedCustomFields && Object.entries(groupedCustomFields).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      sectionName = _ref3[0],
      fields = _ref3[1];
    return {
      title: sectionName.toUpperCase(),
      items: (fields === null || fields === void 0 ? void 0 : fields.map(function (field) {
        return {
          name: field.tag,
          onClick: function onClick() {
            setFieldSelections([].concat(_toConsumableArray(fieldSelections), [{
              field: field,
              value: "",
              isEditing: true,
              editedValue: ""
            }]));
            setCustomFieldSearch("");
          },
          className: "p-[4px] text-[12px]",
          icon: field.tag_type === "date" ? /*#__PURE__*/React.createElement(AwesomeIcon, {
            name: faCalendar,
            className: "w-4 h-4"
          }) : undefined
        };
      })) || []
    };
  }) || [];
  var handleEdit = function handleEdit(index) {
    setFieldSelections(function (prev) {
      return prev.map(function (sel, i) {
        return i === index ? _objectSpread(_objectSpread({}, sel), {}, {
          isEditing: true,
          editedValue: sel.value
        }) : _objectSpread(_objectSpread({}, sel), {}, {
          isEditing: false,
          editedValue: undefined
        });
      });
    });
  };
  var handleValueChange = function handleValueChange(index, value) {
    setFieldSelections(function (prev) {
      return prev.map(function (sel, i) {
        return i === index ? _objectSpread(_objectSpread({}, sel), {}, {
          editedValue: value
        }) : sel;
      });
    });
  };
  var availableCustomFieldsWithAssignee = assigneeField ? [].concat(_toConsumableArray(availableCustomFields), [assigneeField]) : availableCustomFields;
  var handleSave = function handleSave(index) {
    setFieldSelections(function (prev) {
      return prev.map(function (sel, i) {
        if (i === index) {
          var finalValue = sel.editedValue;

          // Convert date values to ISO strings
          if (sel.field.tag_type === "date" && finalValue) {
            finalValue = new Date(finalValue).toISOString();
          }
          return _objectSpread(_objectSpread({}, sel), {}, {
            value: finalValue,
            isEditing: false,
            editedValue: undefined
          });
        }
        return sel;
      });
    });
  };
  var handleCancel = function handleCancel(index) {
    setFieldSelections(function (prev) {
      return prev.filter(function (sel, i) {
        if (i !== index) return true;
        // If new and empty, remove; else just exit edit mode
        if (sel.value === "" && sel.isEditing) return false;
        return true;
      }).map(function (sel, i) {
        return i === index ? _objectSpread(_objectSpread({}, sel), {}, {
          isEditing: false,
          editedValue: undefined
        }) : sel;
      });
    });
  };
  var removeFieldSelection = function removeFieldSelection(index) {
    setFieldSelections(function (prev) {
      return prev.filter(function (_, i) {
        return i !== index;
      });
    });
  };
  var handleBulkTaggingUpdate = function handleBulkTaggingUpdate() {
    var validFields = fieldSelections.filter(function (f) {
      return f.value !== null && f.value !== "";
    });
    onUpdateFields(validFields);
  };
  var handleAssign = function handleAssign() {
    var assignField = customFields.find(function (f) {
      return f.tag_type === "user" && f.additional.isSystemField;
    });
    onAssign(assignField);
  };
  var hasInvalidFields = fieldSelections.some(function (s) {
    // For boolean fields, false is a valid value
    if (s.field.tag_type === "boolean") {
      return s.value === null || s.value === undefined || s.value === "";
    }
    // For other fields, empty string is invalid
    return !s.value || s.value === "";
  });
  useAddBulkTagging(availableCustomFieldsWithAssignee, setFieldSelections, fieldSelections, onSelectAssignee, handleBulkTaggingUpdate, handleAssign);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col bg-blue-50 dark:bg-[#183D3D] text-gray-900 dark:text-white px-7 py-2 text-md"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center bg-blue-100 dark:bg-[#145252] rounded-md px-4 py-2 mr-6 min-w-[80px]"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-2xl font-bold"
  }, selectedCount), /*#__PURE__*/React.createElement("span", {
    className: "text-[12px] text-gray-600 dark:text-gray-200 mt-1"
  }, t("selected_key"))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 flex flex-col gap-4 divide-y divide-gray-300 dark:divide-gray-700"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center pt-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "w-24 capitalize"
  }, t("label.assign_to")), /*#__PURE__*/React.createElement("div", {
    className: "mr-4 min-w-[200px]"
  }, /*#__PURE__*/React.createElement(DropdownMenu, {
    options: assigneeOptions.map(function (option) {
      return {
        name: option,
        onClick: function onClick() {
          onSelectAssignee(option);
        }
      };
    }),
    buttonClassName: "w-full text-[12px] text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-md px-4 py-2 flex items-center justify-between",
    hasArrow: true,
    hasCustomControl: true,
    menuItemClassName: "w-[200px] [&>div]:px-4 [&>div]:py-2 text-[12px]",
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex items-center gap-2"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-gray-700 dark:text-gray-200"
      }, selectedAssignee || t("label.select_assignee")));
    },
    disabled: isBulkTaggingInProgress
  })), /*#__PURE__*/React.createElement("button", {
    className: "bg-green-600 px-4 py-3 rounded text-white disabled:opacity-50 disabled:cursor-not-allowed",
    onClick: handleAssign,
    disabled: !selectedAssignee || isBulkTaggingInProgress || isUpdating
  }, t("label.assign"))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col pt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center mb-4"
  }, /*#__PURE__*/React.createElement("span", {
    className: "w-24"
  }, t("label.set_fields")), /*#__PURE__*/React.createElement("div", {
    className: "mr-4 min-w-[200px]"
  }, /*#__PURE__*/React.createElement(SectionedDropdownMenu, {
    sections: sections,
    isSearch: true,
    search: customFieldSearch,
    setSearch: setCustomFieldSearch,
    buttonClassName: "w-full text-[12px] text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-md px-4 py-2 flex items-center justify-between",
    hasArrow: true,
    hasCustomControl: true,
    menuItemClassName: "w-[200px] [&>div]:px-2 [&>div]:py-2 text-[12px]",
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex items-center gap-2"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faPlus,
        className: "w-4 h-4 text-gray-700 dark:text-white"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-gray-700 dark:text-gray-200"
      }, t("label.add_field")));
    },
    disabled: isBulkTaggingInProgress,
    menuClassName: "!z-10",
    onKeyDown: handleKeyDown,
    scrollableContainerClassName: "!max-h-60"
  })), fieldSelections.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end pt-2"
  }, /*#__PURE__*/React.createElement("button", {
    className: "bg-blue-600 px-4 py-3 rounded text-white disabled:opacity-50 disabled:cursor-not-allowed",
    onClick: handleBulkTaggingUpdate,
    disabled: hasInvalidFields || selectedPatientIds.length === 0 || isBulkTaggingInProgress || isUpdating
  }, t("label.update_all_fields")))), fieldSelections.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap gap-2 p-2 items-center"
  }, fieldSelections.map(function (selection, index) {
    return /*#__PURE__*/React.createElement(TagItem, {
      key: selection.field.uuid,
      field: selection.field,
      value: selection.isEditing ? selection.editedValue : selection.value,
      isEditing: !!selection.isEditing,
      onEdit: function onEdit() {
        return handleEdit(index);
      },
      onSave: function onSave() {
        return handleSave(index);
      },
      onCancel: function onCancel() {
        return handleCancel(index);
      },
      onValueChange: function onValueChange(value) {
        return handleValueChange(index, value);
      },
      onRemove: function onRemove() {
        return removeFieldSelection(index);
      },
      disableEditing: isBulkTaggingInProgress,
      useLegacyDesign: true
    });
  }))))));
};
export default BulkAssignBar;